import io from "socket.io-client";
import Manager from "socket.io-client/lib/manager";

/** @type {Manager} */
let Socket;
const END_URL = process.env.REACT_APP_SOCKET_URL;

const connectSocket = (userId) => {
	if (Socket) {
		Socket.disconnect();
		Socket.removeAllListeners();
	}

	const resolvedUserId =
		userId ||
		(localStorage.getItem("profileInfo") ? JSON.parse(localStorage.getItem("profileInfo"))?.id : "");

	if (!resolvedUserId) {
		// Guard: never open a socket without a userId — the server will reject it with 401.
		console.warn("[Socket] connectSocket skipped — no userId");
		return;
	}

	Socket = io(END_URL, {
		transports: ["websocket"],
		upgrade: false,
		query: { id: resolvedUserId },
		autoConnect: false,
		reconnection: true,
		reconnectionAttempts: 5,
		allowEIO3: true,
	});
};

export { connectSocket, Socket };
